<template>
  <v-flex>
    <v-flex class="display-2 font-weight-black" style="z-index: 1">
      {{ project.name }}
    </v-flex>

    <div
      :style="{
        'background-color': project.data.color,
        width: '80px',
        height: '22px',
        'margin-left': '-5px',
        'margin-top': '-19px'
      }"
    />

    <v-flex class="title font-weight-light project-description">
      {{ project.description }}
    </v-flex>
  </v-flex>
</template>
<script>
import { Project } from "@/classes/Project/Project";
export default {
  props: {
    project: {
      type: Project
    }
  }
};
</script>
<style scoped>
.project-description {
  margin-top: 20px;
  margin-left: 10px;
}
</style>
